module.exports = __webpack_public_path__ + "img/zztbg-1-en.94ebea30.png";